import { Autocomplete, FormControl, TextField } from "@mui/material";

type BrandAutocompleteProps = {
  options: string[];
  loading: boolean | undefined;
  brandSelect(event: React.ChangeEvent<unknown>, ...rest: any[]): void;
};

export function BrandAutocomplete({
  options,
  loading,
  brandSelect,
}: BrandAutocompleteProps) {
  return (
    <FormControl sx={{ minWidth: "180px", maxWidth: "360px" }}>
      <Autocomplete
        loading={loading}
        multiple
        sx={{
          minHeight: "40px",
          "& .MuiAutocomplete-option": {
            fontSize: 15,
            "& > span": {
              mr: 10,
              fontSize: 18,
            },
          },
        }}
        options={options}
        onChange={brandSelect}
        autoHighlight
        size="small"
        renderInput={(params) => (
          <TextField
            {...params}
            label="All Brands"
            slotProps={{
              htmlInput: {
                ...params.inputProps,
                autoComplete: "new-password",
              }
            }}
          />
        )}
      />
    </FormControl>
  );
}
